import React from "react";
import "./Styles/PublicationDetails.scss";

const PublicationDetails = ({ publication, onBack }) => {
  const handleReadMore = () => {
    window.open(publication.link, "_blank");
  };

  return (
    <section className="publication-details">
      <button onClick={onBack}>← Back</button>
      <article className="publication-metadata">
        <h2>{publication.title}</h2>
        <p>
          <strong>Author:</strong> {publication.author}
        </p>
        <p>
          <strong>Publication Date:</strong> {publication.publication_date}
        </p>
        <p>
          <strong>Description:</strong> {publication.description}
        </p>
        <button onClick={handleReadMore}>Read More</button>
      </article>
    </section>
  );
};

export default PublicationDetails;
